// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3b1dQ","name":"ConsentHeader_name__32Rmy","birthday":"ConsentHeader_birthday__kIK5g","skeleton":"ConsentHeader_skeleton__3NqG9"};